/* eslint react/no-danger: 0 */
import {
  useStrings,
  useStringsWithPlaceholders,
} from "@1js/localization-components";
import {
  Image,
  type OnOpenChangeData,
  type OpenPopoverEvents,
} from "@fluentui/react-components";
import {
  TeachingPopover,
  TeachingPopoverBody,
  TeachingPopoverFooter,
  TeachingPopoverSurface,
  TeachingPopoverTitle,
} from "@fluentui/react-teaching-popover";
import React from "react";
import {
  PopoverGotItButton,
  PopoverMessage,
  PopoverPublishToTeam,
  PopoverTitle,
} from "./WorkgroupOwnerTeachingPopover.strings";

export type WorkgroupOwnerTeachingPopoverProps = {
  isEnabled: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  target: any;
  onPopoverStatus: (isOpen: boolean) => void;
};

const id = "copilotPopoverSeen-0002";

export const WorkgroupOwnerTeachingPopover: React.FC<
  WorkgroupOwnerTeachingPopoverProps
> = ({ isEnabled, target, onPopoverStatus }) => {
  const localizations = useStrings({
    PopoverTitle,
    PopoverPublishToTeam,
    PopoverGotItButton,
  });
  const localizationsWithPlaceholders = useStringsWithPlaceholders({
    PopoverMessage,
  });

  const onOpenChange = React.useCallback(
    (_: OpenPopoverEvents, data: OnOpenChangeData) => {
      if (!data.open) {
        localStorage.setItem(id, "true");
        setIsSeen(true);
        onPopoverStatus(false);
      }
    },
    []
  );

  const onClose = React.useCallback(() => {
    localStorage.setItem(id, "true");
    setIsSeen(true);
  }, []);

  const [isSeen, setIsSeen] = React.useState<boolean>(
    localStorage.getItem(id) === "true"
  );

  if (!isEnabled || isSeen) {
    return <></>;
  }

  onPopoverStatus(true);
  return (
    <TeachingPopover
      onOpenChange={onOpenChange}
      open={true}
      withArrow={true}
      positioning={{ target, position: "above", align: "start" }}
    >
      <TeachingPopoverSurface>
        <TeachingPopoverBody
          media={
            <Image
              alt=""
              fit="contain"
              src="/images/0192-people-l-standard-192x192.webp"
              role="presentation"
            />
          }
        >
          <TeachingPopoverTitle>
            {localizations.PopoverTitle()}
          </TeachingPopoverTitle>
          <div
            dangerouslySetInnerHTML={{
              __html: localizationsWithPlaceholders.PopoverMessage({
                action: `<b>${localizations.PopoverPublishToTeam()}</b>`,
              }),
            }}
          ></div>
        </TeachingPopoverBody>
        <TeachingPopoverFooter
          primary={localizations.PopoverGotItButton()}
          onClick={onClose}
        />
      </TeachingPopoverSurface>
    </TeachingPopover>
  );
};

WorkgroupOwnerTeachingPopover.displayName = "WorkgroupOwnerTeachingPopover";
